import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Field from '../../../components/Field';
import validator from 'validator';

class Register extends Component {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.state = {
      fields: props.checkoutState.customer,
      fieldErrors: {}
    };
  }

  onCheckboxChange (e) {
    const name = e.target.name;
    const value = e.target.checked;
    this.onInputChange(
      {
        name: name,
        value: value,
        error: null
      });
  }

  onInputChange (input) {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    fields[input.name] = input.value;
    fieldErrors[input.name] = input.error;
    this.setState({ fields, fieldErrors });
  }

  onSubmit (e) {
    e.preventDefault();
    if (this.validate()) {
      const stepState = {
        customer: this.state.fields
      };
      this.props.onSubmit(1, stepState);

      /* -- for when there was a waiting list
      if (this.props.checkoutState.course.type === 'independent' ||
        this.props.checkoutState.course.title.indexOf('Level 1') > -1) {
        this.props.onSubmit(1, stepState);
      } else {
        this.props.onSubmit(3, stepState);
      } -- */
    }
  }

  validate () {
    const customer = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter((k) => fieldErrors[k]);
    if (!customer.name) return false;
    if (!customer.email) return false;
    if (errMessages.length) return false;
    return true;
  }

  render () {
    return (
      <form onSubmit={this.onFormSubmit} className='checkout__form'>
        <h2>Your details</h2>
        <p>We need this to create your learning plan and save your progress</p>
        <ul className='form-fields form-fields--two-col simple-inputs'>
          <li>
            <label htmlFor='name'>Name</label>
            <Field
              name='name'
              type='text'
              value={this.state.fields.name}
              onChange={this.onInputChange}
              validate={(val) => (val ? false : 'Name Required')}
            />
          </li>
          <li>
            <label htmlFor='emailAddress'>Email</label>
            <Field
              name='email'
              type='email'
              value={this.state.fields.email}
              onChange={this.onInputChange}
              validate={(val) => (validator.isEmail(val) ? false : 'Invalid Email')}
            />
          </li>
          <li>
            <p className='label-extra'>
              <input
                type='checkbox'
                id='news'
                name='news'
                onChange={this.onCheckboxChange}
                checked={this.state.fields.news} />
                Tick this box if you would like to receive emails of discounted courses and any BSL news</p>
          </li>
          <li className='form-footer'>
            <button onClick={this.onSubmit} className='button button--l disabled' disabled={!this.validate()}>Next</button>
          </li>
        </ul>
      </form>
    );
  }
}

Register.propTypes = {
  checkoutState: PropTypes.object,
  onSubmit: PropTypes.func.isRequired
};

export default Register;



// WEBPACK FOOTER //
// ./src/views/Checkout/Register/index.js